import { RfxTab } from "newui/features/Rfx/types/component-types";
import { BasePaths } from "./navigation.types";

export class GuestPaths extends BasePaths {
	rfx;

	constructor() {
		super("/account/");
		this.home = this.prefixWithBasePath("rfx");

		this.rfx = {
			all: this.prefixWithBasePath("rfx"),
		};
	}

	viewRfxApproval(rfxId: number) {
		return this.prefixWithBasePath(`rfx/${rfxId}/view-approval`);
	}

	viewRfxEvaluationPanel(rfxId: number) {
		return this.prefixWithBasePath(`rfx/${rfxId}/evaluation`);
	}

	/**
	 *
	 * @param rfxId The id of the RFx invite being viewed
	 * @param tabId Optional id of the tab to navigate to
	 * @param contextId Optional id for the tab context
	 * @returns Full Url for viewing a given RFx
	 */
	viewRfxSubmission(
		rfxId: number,
		tabId: RfxTab | null = null,
		contextId: number | string | null = null
	) {
		const basePath = this.prefixWithBasePath(`rfx/${rfxId}/submission`);

		if (!tabId) {
			return basePath;
		}

		return `${basePath}/${tabId}/${contextId ? contextId : ""}`;
	}
}
